export default __webpack_public_path__ + "static/media/coreCard5.bae67c54.svg";